import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";

import { fetchPage } from "./actionCreator";

export const pageViewSlice = createSlice({
  name: "pageView",
  initialState,
  reducers: {
    changeCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setPages(state, action) {
      state.pages = action.payload;
    },
    setPaginationModel(state, action) {
      state.paginationModel = action.payload;
    },
    setColumnOrder(state, action) {
      state.columnOrder = action.payload;
    },
    setRowData(state, { payload }) {
      const rows = JSON.parse(JSON.stringify(state.rows));
      const row = rows[payload.rowId];
      row[payload.columnId] = payload.value;
      state.rows = rows;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPage.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchPage.fulfilled, (state, action) => {
      state.loading = false;
      state.error = "";
      state.rows = action.payload.rows;
      state.columns = action.payload.columns;
      state.columnOrder = action.payload.columnOrder;
    });
    builder.addCase(fetchPage.rejected, (state) => {
      state.loading = false;
      state.rows = [];
      state.columns = [];
      state.error = "Unable to get data";
    });
  },
});

const {
  changeCurrentPage: pageViewChangeCurrentPage,
  setPages: setPageViewPages,
  setPaginationModel: setPageViewPaginationModel,
  setColumnOrder,
  setRowData,
} = pageViewSlice.actions;

export {
  pageViewChangeCurrentPage,
  setPageViewPages,
  setPageViewPaginationModel,
  setColumnOrder,
  setRowData,
};

export default pageViewSlice.reducer;
